import { useState } from 'react'

import { Button, Flex, Spinner } from '@vtex/shoreline'

import { useAPPTranslation } from '~/i18n/useAPPTranslation'
import { LinkInsertionOrder } from '~/modules/retailMedia/components/LinkInsertionOrder'

import styles from './styles.module.css'

type LinkBlockProps = {
  linkedIds: InsertionOrderId[]
  isLinking: boolean
  /** Another link/unlink request is in flight */
  isPending: boolean
  onLink: (insertionOrder: InsertionOrder) => void
  onCancel: () => void
}

/** Inline block at the end of the list, where the new PI will show up. */
export const CampaignInsertionOrderLinkBlock = ({
  linkedIds,
  isLinking,
  isPending,
  onLink,
  onCancel
}: LinkBlockProps) => {
  const { t } = useAPPTranslation()
  const [selected, setSelected] = useState<InsertionOrder | null>(null)

  const missingCheckingAccount = !!selected && !selected.checking_account_id

  return (
    <div className={styles.linkBlock} data-testid="campaign-io-link-block">
      <LinkInsertionOrder
        value={selected}
        onChange={setSelected}
        excludedIds={linkedIds}
        required
        autoFocus
        disabled={isPending}
        error={
          missingCheckingAccount
            ? t('rm:campaign.insertionOrder.missingCheckingAccount')
            : undefined
        }
      />

      <Flex justify="flex-end" gap="$space-2" style={{ flexWrap: 'wrap' }}>
        <Button
          variant="secondary"
          onClick={onCancel}
          disabled={isPending}
          data-testid="campaign-io-link-cancel"
        >
          {t('c:actions.cancel')}
        </Button>
        <Button
          variant="primary"
          onClick={() => selected && onLink(selected)}
          disabled={!selected || missingCheckingAccount || isPending}
          aria-busy={isLinking}
          data-testid="campaign-io-link-submit"
        >
          {isLinking ? (
            <>
              <Spinner size={16} />
              {t('rm:campaign.detail.insertionOrder.actions.linking')}
            </>
          ) : (
            t('rm:campaign.detail.insertionOrder.actions.confirmLink')
          )}
        </Button>
      </Flex>
    </div>
  )
}
